// Shared CPU trail state; signed strength encodes origin without another texture.
export const MAX_TRAIL = 128;

export default class PointerWave {
    constructor(bounds) {
        this.bounds = bounds;
        this.params = { fadeTime: 2.0, trailSpacing: 0.1 };
        this.trail = [];
        this.lastPoint = null;
        this.timeSinceLastMove = 0;
        this.randomPointTimer = 0;
        this.isPlacingRandomPoints = true;
        this.randomPointStrength = 0.8;
    }

    recordPointer(x, z) {
        if (!Number.isFinite(x) || !Number.isFinite(z)) return;
        // Activity counts even when spacing rejects a redundant sample.
        this.timeSinceLastMove = 0;
        this.isPlacingRandomPoints = false;
        this.randomPointTimer = 0;
        if (this.lastPoint && Math.hypot(x - this.lastPoint.x, z - this.lastPoint.z) < this.params.trailSpacing) return;
        this.append({ x, z, age: 0, strength: -1 });
        this.lastPoint = { x, z };
    }

    leave() {
        this.lastPoint = null;
    }

    append(point) {
        if (this.trail.length >= MAX_TRAIL) this.trail.shift();
        this.trail.push(point);
    }

    addRandomPoint() {
        this.append({
            x: (Math.random() * 0.5 - 0.25) * this.bounds,
            z: (Math.random() * 0.5 - 0.25) * this.bounds,
            age: 0,
            strength: this.randomPointStrength + Math.random() * 0.2,
        });
    }

    update(delta) {
        for (let i = this.trail.length - 1; i >= 0; i--) {
            this.trail[i].age += delta;
            if (this.trail[i].age > this.params.fadeTime * 4) this.trail.splice(i, 1);
        }
        this.timeSinceLastMove += delta;
        if (this.timeSinceLastMove >= 3 && !this.isPlacingRandomPoints) {
            this.leave();
            this.isPlacingRandomPoints = true;
            this.randomPointTimer = 0;
        }
        if (this.isPlacingRandomPoints) {
            this.randomPointTimer += delta;
            if (this.randomPointTimer >= 1.5) {
                this.addRandomPoint();
                this.randomPointTimer = 0;
            }
        }
    }
}
